/**
 * 備考 (note) の表示用コンポーネント。`http://` / `https://` の URL だけをリンクにし、改行を保って表示する。
 *
 * 安全性:
 *   - 備考は React のテキストノードとして描画する (`dangerouslySetInnerHTML` は使わない)。`<script>` 等は文字のまま出る。
 *   - リンクにするのは `http(s)` だけ。分解は `utils/linkify.ts` を参照。
 *   - 別タブで開くときの `window.opener` 参照を避けるため `rel="noopener noreferrer"` を付ける。
 *   - リンクを押しても、このコンポーネントを内包する行 (例: Picker の行クリックで選択) を誤操作させないよう、
 *     クリックの伝播を止める。
 */
import type React from 'react';

import { linkify } from '../utils/linkify';

export interface LinkifiedTextProps {
  text: string;
  className?: string;
  'data-testid'?: string;
}

export function LinkifiedText(props: LinkifiedTextProps): React.JSX.Element {
  const parts = linkify(props.text);
  return (
    <span
      className={['linkified-text', props.className].filter(Boolean).join(' ')}
      data-testid={props['data-testid']}
    >
      {parts.map((part, index) =>
        part.type === 'link' ? (
          <a
            key={index}
            href={part.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {part.text}
          </a>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </span>
  );
}
